<div *ngIf="params.data && params.from != 'projectPages'" class="btn-div">
  <div class="editTimeActionButton" *ngIf="isEditMode(); else actionBtn">
    <button class="inlineActionButton">
      <span class="textDrpInline" id="1" (click)="saveInlineGrid()"
        ><img width="15" height="15" src="./assets/icons/inlineCheckmark.svg"
      /></span>
    </button>
    <button class="inlineActionButton">
      <span class="textDrpInline ml-20" (click)="clearInlineEdit()"
        ><img width="14.78" height="15.04" src="./assets/icons/inlineCross.svg"
      /></span>
    </button>
  </div>
  <ng-template #actionBtn>
    <div class="addTimeActionButton">
      <button
        class="inlineActionButton"
        *ngIf="
          ((params.from == 'customMaterialProcess' && !params.data.isEdit) ||
            params.showInlineEdit) &&
          isLastChild
        "
        [ngClass]="!params.showInlineDelete && !params.showInlineCopy ? 'onlyEdit' : ''"
      >
        <span class="textDrpInline"
          ><img width="15" height="15" src="./assets/icons/Group 30.svg" (click)="editInlineGrid()"
        /></span>
      </button>
      <button class="inlineActionButton" *ngIf="params.showInlineCopy">
        <span class="textDrpInline"
          ><i class="fa fa-copy copyInlineBtn" (click)="copyData()"></i
        ></span>
      </button>
      <button class="inlineActionButton" *ngIf="params.showInlineDelete">
        <span class="textDrpInline" [style.margin-left.px]="!params.showInlineCopy ? '20' : '10'"
          ><img
            width="14.78"
            height="15.04"
            src="./assets/icons/inlineDelete.svg"
            (click)="deleteInlineGrid()"
        /></span>
      </button>
    </div>
  </ng-template>
</div>

<div *ngIf="params.data && params.from == 'projectPages' && !params.data.isOrigin" class="btn-div">
  <div
    class="editTimeActionButton"
    *ngIf="params.data.enableEditing; else showSaveProjectPackButton"
  >
    <button class="inlineActionButton">
      <span class="textDrpInline" id="2" (click)="saveInlineGridProject()"
        ><img width="15" height="15" src="./assets/icons/inlineCheckmark.svg"
      /></span>
    </button>
    <button class="inlineActionButton">
      <span class="textDrpInline ml-20" (click)="clearInlineEditProject()"
        ><img width="14.78" height="15.04" src="./assets/icons/inlineCross.svg"
      /></span>
    </button>
  </div>
  <ng-template #showSaveProjectPackButton>
    <div class="addTimeActionButton">
      <button
        class="inlineActionButton"
        *ngIf="params.showInlineEdit"
        [ngClass]="!params.showInlineDelete && !params.showInlineCopy ? 'onlyEdit' : ''"
      >
        <span class="textDrpInline"
          ><img
            width="15"
            height="15"
            src="./assets/icons/inlineEdit.svg"
            (click)="editInlineForProject()"
        /></span>
      </button>
      <button class="inlineActionButton" *ngIf="params.showInlineCopy">
        <span class="textDrpInline"
          ><i class="fa fa-copy copyInlineBtn" (click)="copyData()"></i
        ></span>
      </button>
      <button class="inlineActionButton" *ngIf="params.showInlineDelete">
        <span class="textDrpInline" [style.margin-left.px]="!params.showInlineCopy ? '20' : '10'"
          ><img
            width="14.78"
            height="15.04"
            src="./assets/icons/inlineDelete.svg"
            (click)="deleteInlineGrid()"
        /></span>
      </button>
    </div>
  </ng-template>
</div>
